export default __webpack_public_path__ + "static/media/duration.6584fa86.svg";